import React from 'react'
import { connect } from 'react-redux'
import {  Row,  Table, FormControl } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'
import Toggle from 'react-toggle'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../../messages'

import {fetchProductsDashboard, fetchProduct, updateProduct} from '../../../actions/product-actions';

const Checkbox = ({ checked, onChange }) => (
  <label className="toggle" style={{padding:"10px", paddingLeft:"5px", display:"inline-block"}} >
    <span className="label"></span>
    <Toggle
      checked={checked}
      icons={{
        checked: null,
        unchecked: null,
      }}
      onChange={onChange}
    />
  </label>
)

class ProductEditionOverview extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, overViewmode: true, detailMode:false,
          editingMode:false, selectedProduct:undefined, editedProduct:undefined, toggleValue:false, isSearching: false  }
      }
    
      componentDidMount() {
        if(this.props.productResults.query) {
          this.setState({ query: this.props.productResults.query })
        }
        console.log('props after mounting ', this.props)
        //if(this.props.productResults){
        //  this.setState({ toggleValue: this.props.results[0].deactivationPossible })
        //}
      }

     componentWillUnmount() {
       this.setState({ query: undefined, overViewmode: true, detailMode:false,
        editingMode:false, selectedProduct:undefined, editedProduct:undefined, toggleValue:false })
     }

      search(query) {
        this.setState({ query, overViewmode: true, isSearching: true })
        this.props.fetchProductsDashboard(query).then(() => {
          this.setState({ isSearching: false })
        })
      }

      onChangeActivationUrl(e) {
        this.state.editedProduct.activationPageUrl = e.target.value;
      }

      onChangeDeactivationPeriod(e) {
        this.state.editedProduct.deactivationPeriod = e.target.value;
      }

      onChangeProductPageUrl(e) {
        this.state.editedProduct.productPageUrl = e.target.value;
      }

      onChangeActivationPeriodNew(e) {
        this.state.editedProduct.activationPeriodNew = e.target.value;
      }

      onChangeDeactivationPossible(e) {
        this.state.editedProduct.deactivationPossible = !this.state.editedProduct.deactivationPossible 
        this.setState({toggleValue: this.state.editedProduct.deactivationPossible})
      }

      persistProduct() {
        this.setState({selectedProduct: this.state.editedProduct})
        //save
        this.props.updateProduct(this.state.selectedProduct).then(() => {
          this.props.fetchProduct(this.state.selectedProduct.id);
        });
        this.changeToDetailMode(this.state.selectedProduct);
      }

      changeToDetailMode(product){
        this.setState({overViewmode: false})
        this.setState({detailMode: true})
        this.setState({editingMode: false})
        this.setState({selectedProduct: product})
      }

      changeToOverview(){
        this.setState({overViewmode: true})
        this.setState({detailMode: false})
        this.setState({editingMode: false})
      }

      changeToEditingMode(){
        this.setState({editedProduct: this.state.selectedProduct})
        this.setState({overViewmode: false})
        this.setState({detailMode: false})
        this.setState({editingMode: true})
        this.setState({toggleValue: this.state.selectedProduct.deactivationPossible})
        console.log(this.state.selectedProduct);
      }
    
      render() {
        const { productResults, editedProduct } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='user' 
              text=" Producten verrijken" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                Zoek 
                </div>
                <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="Zoek product / EAN"
                value={this.state.query || this.props.productResults.query}
                callback={(query) => this.search(query)}
                isLoading={this.state.isSearching}
                />
              </div>
          </Row>
          </Row>
        <Row>
          <div className="tablescontainer" style={{marginTop:"5px"}}>
            { this.state.overViewmode && productResults.length? (
              <Table striped>
                <thead>
                  <tr>
                    <th>Ean</th>
                    <th>Activatiepagina URL</th>
                    <th>Deactivatieperiode</th>
                    <th>Productpagina URL</th>
                    <th>Activatie periode</th>
                    <th>Deactivation possible</th>
                  </tr>
                </thead>
                <tbody>
                  {productResults.map((product, index) => (
                    <tr key={index} onClick={(e) => this.changeToDetailMode(product)}>
                    <td>{product.ean}</td>
                    <td>{product.activationPageUrl ? product.activationPageUrl : ""}</td>
                    <td>{product.deactivationPeriod ? product.deactivationPeriod : ""}</td>
                    <td>{product.productPageUrl ? product.productPageUrl : "" }</td>
                    <td>{product.activationPeriodNew}</td>
                    <Checkbox checked={product.deactivationPossible? true : false } onChange={e => {}} />
                  </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div />
            )}
          </div>
        </Row>
        <Row>
        <div className="tablescontainer" style={{marginTop:"5px", width:"50%" }}>
          { this.state.detailMode === true  && this.state.selectedProduct ?
          ( 
          <Table className='DashboardProductDetail' style={{display:"inline-flex"}} striped>
            <thead className='DashboardProductDetailThead' style={{backgroundColor:"none"}}>
              <tr>
              <th style={{fontWeight:"bold", color:"black"}} >{this.state.selectedProduct.ean}</th>
              <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ean</td>
                <td>{this.state.selectedProduct.ean}</td>
              </tr>
              <tr>
                <td>Name</td>
                <td>{this.state.selectedProduct.name}</td>
              </tr>
              <tr>
                <td>Nav product Id</td>
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button>
              </tr>
              <tr>
                <td>License extendable</td>
                <button className="button-dashboard-product" onClick={() => {}}>{this.state.selectedProduct.extendable ? 'Ja' : 'NEE'}</button>
              </tr>
              <tr>
                <td>Activatiepagina URL</td>
                <td>{this.state.selectedProduct.activationPageUrl ? this.state.selectedProduct.activationPageUrl : "Niets"}</td>
              </tr>
              <tr>
                <td>Deactivatieperiode</td>
                <button className="button-dashboard-product" onClick={() => {}}>
                  {this.state.selectedProduct.deactivationPeriod ? this.state.selectedProduct.deactivationPeriod : "Niets"}</button>
              </tr>
              <tr>
                <td>Productpagina URL</td>
                <td>{this.state.selectedProduct.productPageUrl ? this.state.selectedProduct.productPageUrl : "Niets"}</td>
              </tr>
              <tr>
                <td>Activatie periode</td>
                <td>{this.state.selectedProduct.activationPeriodNew ? this.state.selectedProduct.activationPeriodNew : ""}</td>
              </tr>
              <tr>
                <td>Mogelijkheid deactiveren </td>
                <button className="button-dashboard-product" onClick={() => {}}>{this.state.selectedProduct.deactivationPossible ? 'Ja' : 'NEE' }</button>
              </tr>
            </tbody>
            <Row>
            <button className="button-dashboard-product" style={{marginLeft:"20px"}} onClick={() => this.changeToOverview()}>Terug naar overzicht</button>
            <button className="button-dashboard-product" onClick={() => this.changeToEditingMode()}>Bewerken</button>
            </Row>

          </Table>

          ) :
          (<div></div>)
          }
          </div>
        </Row>
        <Row>
        <div className="tablescontainer" style={{marginTop:"-100px" }}>
          { this.state.editingMode === true  && this.state.editedProduct ?
          ( 
          <Table className='DashboardProductDetail' style={{display:"inline" }} striped>
            <thead className='DashboardProductDetailThead' style={{backgroundColor:"none"}}>
              <tr>
              <th style={{fontWeight:"bold", color:"black"}} >Product Bewerken - {this.state.selectedProduct.ean}</th>
              <th></th>
              </tr>
            </thead>
            <tbody>
            <tr>
                <td>Activatiepagina URL</td>
                <td> <FormControl 
                  type='text' 
                  autoFocus={true} 
                  defaultValue={this.state.editedProduct.activationPageUrl ? this.state.editedProduct.activationPageUrl : ""} 
                  placeholder={'' } 
                  onChange={(e) => this.onChangeActivationUrl(e)} /> </td>
              </tr>
              <tr>
                <td>Deactivatieperiode</td>
                <td> <FormControl 
                  type='text' 
                  autoFocus={true} 
                  defaultValue={this.state.editedProduct.deactivationPeriod ? this.state.editedProduct.deactivationPeriod : ""} 
                  placeholder={'' } 
                  onChange={(e) => this.onChangeDeactivationPeriod(e)} /> </td>
              </tr>
              <tr>
                <td>Productpagina URL</td>
                <td> <FormControl 
                  type='text' 
                  autoFocus={true} 
                  defaultValue={this.state.editedProduct.productPageUrl ? this.state.editedProduct.productPageUrl : ""} 
                  placeholder={'' } 
                  onChange={(e) => this.onChangeProductPageUrl(e)} /> </td>
              </tr>
              <tr>
                <td>Activatie periode</td>
                <td> <FormControl 
                  type='text' 
                  autoFocus={true} 
                  defaultValue={this.state.editedProduct.activationPeriodNew ? this.state.editedProduct.activationPeriodNew : ""} 
                  placeholder={'' } 
                  onChange={(e) => this.onChangeActivationPeriodNew(e)} /> </td>
              </tr>
              <tr>
                <td>Mogelijkheid deactiveren</td>
                <td><Checkbox checked={ this.state.toggleValue } onChange={e => {this.onChangeDeactivationPossible()}} /> </td>
              </tr>
            </tbody>
            <Row>
            <button className="button-dashboard-product-no-background" style={{marginLeft:"20px"}} onClick={() => this.changeToOverview()}>Annuleren</button>
            <button className="button-dashboard-product" onClick={() => this.persistProduct()}>Opslaan</button>
            </Row>

          </Table>

          ) :
          (<div></div>)
          }
          </div>
        </Row>
        </div>
      }

    
}

let SearchInfo = () => (
    <div>
      <p>{SEARCH_INSTRUCTIONS}</p>
      <p>Zoek op:</p>
      <ul>
        <li>Producten ID</li>
      </ul>
      <p>{NO_SEARCH_RESULTS}</p>
    </div>
  )

  export default connect((state) => {
    return { 
    productResults: state.products.searchResults,
    selectedProduct: state.products.detail,
    query: state.dashboard.userLicenseSearchDashboard.query
  }}, {
    fetchProductsDashboard,
    fetchProduct,
    updateProduct
  })(ProductEditionOverview)